import noop from '@gaia/util/noop/action'

export default {
  index: noop,
  bottomSheet: noop,
}
